import Icon from '../components/Icon.vue'

Icon.register({"video-slash":{"width":640,"height":512,"paths":[{"d":"M633.8 458.1L578.8 415.6C594.2 414.2 608 401.9 608 384.5V127.5C608 102 578.9 87.1 557.6 101.7L448 177.3V314.5L416 289.8V111.8C416 85.4 394.6 64 368.2 64H123.9L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L42.7 82 416 370.6 594.5 508.6C601.5 514 611.5 512.8 617 505.8L636.6 480.5C642.1 473.6 640.8 463.5 633.8 458.1zM32 400.2C32 426.6 53.4 448 79.8 448H368.2C379.4 448 389.6 444 397.8 437.5L32 154.7V400.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/video-slash.js
// module id = null
// module chunks = 